export default __webpack_public_path__ + "static/media/boat.5d6c3371.png";